import { GIT_SYNC_FEATURE_FLAG } from "../../shared/featureFlagNames";
import { queries } from "../../shared/queries";
import { useFeatureFlag } from "./useFeatureFlag";
import { useQuery } from "./useQuery";

// Mirrors the server's isSpaceGitSynced (services/shared/mutators/syncGit.ts)
// so the UI never offers an action the server refuses.
export function useIsGitSynced(spaceId: string): boolean {
  const enabled = useFeatureFlag(GIT_SYNC_FEATURE_FLAG);
  const [gitRemote] = useQuery(queries.loadSpaceGitRemote({ spaceId }));
  return Boolean(enabled) && gitRemote != null;
}
